export const categories = [
  { id: "guochan", name: "国产剧", icon: "ri-film-line" },
  { id: "hanju", name: "韩剧", icon: "ri-earth-line" },
  { id: "meiju", name: "美剧", icon: "ri-flag-line" },
  { id: "riju", name: "日剧", icon: "ri-sun-line" },
  { id: "dongman", name: "动漫", icon: "ri-rocket-line" },
  { id: "zongyi", name: "综艺", icon: "ri-tv-line" },
  { id: "jilupian", name: "纪录片", icon: "ri-camera-line" },
  { id: "dianying", name: "电影", icon: "ri-movie-line" },
];

export interface Episode {
  id: number;
  title: string;
  duration: string;
}

export interface TvSeries {
  id: number;
  title: string;
  description: string;
  fullDescription: string;
  categoryId: string;
  year: number;
  rating: number;
  coverImage: string;
  bannerImage: string;
  director: string;
  actors: string[];
  region: string;
  language: string;
  totalEpisodes: number;
  status: string;
  updateInfo: string;
  tags: string[];
  episodes: Episode[];
  releaseDate: string;
}

export const tvSeriesList: TvSeries[] = [
  {
    id: 1,
    title: "长安十二时辰",
    description: "唐朝天宝三载，上元节前夕，长安城陷入一场惊天阴谋。死囚张小敬临危受命，与靖安司司丞李必携手在十二个时辰内拯救长安。",
    fullDescription: "唐朝天宝三载，上元节前夕，长安城陷入一场惊天阴谋。死囚张小敬临危受命，与靖安司司丞李必携手在十二个时辰内拯救长安。本剧改编自马伯庸同名小说，以大唐盛世为背景，通过紧张刺激的悬疑叙事展现了盛唐时期的政治斗争、社会风貌和人物命运。每一集对应一个时辰，节奏紧凑，悬念迭起，被誉为近年国产古装悬疑剧的巅峰之作。剧中不仅有扣人心弦的剧情，更在大唐文化的还原上达到极致，从服饰、礼仪到建筑、饮食，无一处不精心考究。",
    categoryId: "guochan",
    year: 2019,
    rating: 8.2,
    coverImage: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20Tang%20Dynasty%20style%20TV%20series%20poster%2C%20mysterious%20atmosphere%2C%20warm%20golden%20lantern%20light%2C%20traditional%20Chinese%20architecture%20silhouette%2C%20cinematic%20movie%20poster%20design%2C%20clean%20simple%20background%20with%20dark%20gradient%2C%20professional%20drama%20series%20artwork&width=600&height=800&seq=tv-cover-1&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Tang%20Dynasty%20ancient%20Chinese%20city%20at%20night%20with%20red%20lanterns%2C%20majestic%20palace%20architecture%2C%20mysterious%20atmospheric%20lighting%2C%20cinematic%20wide%20shot%2C%20dark%20blue%20and%20gold%20color%20scheme%2C%20epic%20scale%2C%20film%20grain%20texture&width=1600&height=600&seq=tv-banner-1&orientation=landscape",
    director: "曹盾",
    actors: ["雷佳音", "易烊千玺", "周一围", "热依扎"],
    region: "中国大陆",
    language: "汉语普通话",
    totalEpisodes: 48,
    status: "已完结",
    updateInfo: "全48集",
    tags: ["悬疑", "古装", "历史", "剧情"],
    episodes: [
      { id: 1, title: "巳正·大荒落", duration: "45分钟" },
      { id: 2, title: "午初·阳气动", duration: "45分钟" },
      { id: 3, title: "午正·日中", duration: "45分钟" },
      { id: 4, title: "未初·日昳", duration: "45分钟" },
      { id: 5, title: "未正·晡时", duration: "45分钟" },
      { id: 6, title: "申初·夕食", duration: "45分钟" },
    ],
    releaseDate: "2019-06-27",
  },
  {
    id: 2,
    title: "狂飙",
    description: "以一线刑警安欣与黑恶势力长达二十年的生死较量为主线，展现扫黑除恶惊心动魄的斗争历程，是一部硬核现实主义力作。",
    fullDescription: "以一线刑警安欣与黑恶势力长达二十年的生死较量为主线，展现扫黑除恶惊心动魄的斗争历程。故事从一桩看似普通的命案开始，牵扯出盘踞多年的黑恶势力网络。刑警安欣与高启强这对曾经的战友，在正义与邪恶的道路上渐行渐远，二十年的恩怨纠葛，最终在扫黑除恶的雷霆行动中迎来决战。本剧以真实案件为蓝本，通过细腻的人物刻画和紧张的叙事节奏，深刻反映了当代中国社会法治建设的伟大进程，被誉为国产刑侦剧的里程碑之作。",
    categoryId: "guochan",
    year: 2023,
    rating: 8.5,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20dark%20urban%20night%20scene%2C%20two%20men%20facing%20each%20other%20in%20tension%2C%20rainy%20street%20with%20neon%20reflections%2C%20cinematic%20noir%20style%2C%20clean%20dark%20background%2C%20dramatic%20lighting&width=600&height=800&seq=tv-cover-2&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Chinese%20urban%20cityscape%20at%20night%20with%20rain%2C%20modern%20skyscrapers%2C%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20dark%20moody%20atmosphere%2C%20cinematic%20crime%20drama%20aesthetic%2C%20wide%20angle%2C%20professional%20film%20look&width=1600&height=600&seq=tv-banner-2&orientation=landscape",
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐", "张志坚"],
    region: "中国大陆",
    language: "汉语普通话",
    totalEpisodes: 39,
    status: "已完结",
    updateInfo: "全39集",
    tags: ["刑侦", "扫黑", "剧情", "现实主义"],
    episodes: [
      { id: 1, title: "第一集", duration: "45分钟" },
      { id: 2, title: "第二集", duration: "45分钟" },
      { id: 3, title: "第三集", duration: "45分钟" },
      { id: 4, title: "第四集", duration: "45分钟" },
      { id: 5, title: "第五集", duration: "45分钟" },
    ],
    releaseDate: "2023-01-14",
  },
  {
    id: 3,
    title: "黑暗荣耀",
    description: "年少时遭受校园暴力的文东恩，精心策划了一场跨越十余年的复仇计划。当她以老师的身份出现在施暴者孩子面前时，一场精心布局的复仇大戏拉开序幕。",
    fullDescription: "年少时遭受校园暴力的文东恩，精心策划了一场跨越十余年的复仇计划。当她以老师的身份出现在施暴者孩子面前时，一场精心布局的复仇大戏由此展开。本剧由韩国金牌编剧金银淑打造，宋慧乔细腻演绎了一位被欺凌少女从绝望到复仇的心路历程。剧情以校园暴力为切入点，深入探讨了阶级固化、权力霸凌等社会议题，节奏明快，反转不断，每一集都充满戏剧张力。该剧在全球范围内引发了对校园暴力问题的广泛讨论，成为现象级韩剧。",
    categoryId: "hanju",
    year: 2022,
    rating: 8.9,
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20drama%20revenge%20thriller%20poster%2C%20elegant%20woman%20in%20dark%20suit%2C%20cold%20expression%2C%20dark%20minimalist%20background%20with%20subtle%20flowers%2C%20cinematic%20Korean%20drama%20artwork%2C%20mysterious%20and%20elegant%20mood%2C%20professional%20design&width=600&height=800&seq=tv-cover-3&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Elegant%20dark%20Korean%20aesthetic%20scene%2C%20minimalist%20interior%20with%20soft%20shadows%2C%20white%20flowers%20on%20dark%20surface%2C%20mysterious%20atmospheric%20lighting%2C%20cinematic%20mood%2C%20Korean%20drama%20visual%20style%2C%20deep%20contrast&width=1600&height=600&seq=tv-banner-3&orientation=landscape",
    director: "安吉镐",
    actors: ["宋慧乔", "李到晛", "林智妍", "廉惠兰"],
    region: "韩国",
    language: "韩语",
    totalEpisodes: 16,
    status: "已完结",
    updateInfo: "全16集",
    tags: ["复仇", "校园暴力", "悬疑", "剧情"],
    episodes: [
      { id: 1, title: "第一集", duration: "52分钟" },
      { id: 2, title: "第二集", duration: "55分钟" },
      { id: 3, title: "第三集", duration: "50分钟" },
      { id: 4, title: "第四集", duration: "53分钟" },
    ],
    releaseDate: "2022-12-30",
  },
  {
    id: 4,
    title: "绝命毒师",
    description: "一位普通的高中化学老师沃尔特·怀特在得知自己身患绝症后，为了给家人留下财产，利用自己的化学知识开始制造冰毒，从此踏上了一条不归路。",
    fullDescription: "一位普通的高中化学老师沃尔特·怀特在得知自己身患绝症后，为了给家人留下财产，利用自己的化学知识开始制造冰毒，从此踏上了一条不归路。本剧被誉为史上最伟大的电视剧之一，布莱恩·克兰斯顿将一位从懦弱教师到冷酷毒枭的转变演绎得淋漓尽致。五季的叙事如精密化学实验般层层推进，每个角色的命运都紧密交织。剧集不仅是一部扣人心弦的犯罪故事，更是对人性的深刻剖析——当普通人面对绝境时，究竟能走多远。",
    categoryId: "meiju",
    year: 2008,
    rating: 9.5,
    coverImage: "https://readdy.ai/api/search-image?query=American%20drama%20Breaking%20Bad%20style%20poster%2C%20man%20in%20hazmat%20suit%20in%20desert%20landscape%2C%20golden%20hour%20lighting%2C%20chemical%20green%20accents%2C%20cinematic%20drama%20series%20artwork%2C%20minimalist%20and%20striking%20composition%2C%20clean%20background&width=600&height=800&seq=tv-cover-4&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=American%20southwest%20desert%20landscape%20at%20sunset%2C%20wide%20open%20horizon%2C%20warm%20golden%20light%2C%20dramatic%20sky%2C%20cinematic%20western%20atmosphere%2C%20solitary%20RV%20on%20distant%20road%2C%20epic%20scale&width=1600&height=600&seq=tv-banner-4&orientation=landscape",
    director: "文斯·吉里根",
    actors: ["布莱恩·克兰斯顿", "亚伦·保尔", "安娜·冈"],
    region: "美国",
    language: "英语",
    totalEpisodes: 62,
    status: "已完结",
    updateInfo: "全5季62集",
    tags: ["犯罪", "剧情", "黑色幽默", "经典"],
    episodes: [
      { id: 1, title: "试播集", duration: "58分钟" },
      { id: 2, title: "猫在袋中", duration: "48分钟" },
      { id: 3, title: "以及袋中之猫", duration: "48分钟" },
      { id: 4, title: "癌症患者", duration: "48分钟" },
    ],
    releaseDate: "2008-01-20",
  },
  {
    id: 5,
    title: "鬼灭之刃",
    description: "大正时期的日本，少年灶门炭治郎全家惨遭鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复为人类的方法，炭治郎踏上了斩鬼之旅。",
    fullDescription: "大正时期的日本，少年灶门炭治郎全家惨遭鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复为人类的方法，炭治郎踏上了斩鬼之旅。本作改编自吾峠呼世晴的同名漫画，由ufotable制作，以精良到极致的作画和战斗场面著称。故事融合了热血、亲情与日式美学，炭治郎的坚韧与温柔打动了全球无数观众。剧场版《无限列车篇》更是创造了日本影史票房纪录。",
    categoryId: "dongman",
    year: 2019,
    rating: 9.1,
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20anime%20demon%20slayer%20style%20poster%2C%20young%20swordsman%20with%20green%20checkered%20pattern%2C%20water%20breathing%20effects%2C%20dark%20night%20background%20with%20moon%2C%20dynamic%20anime%20art%20style%2C%20vibrant%20colors%2C%20action%20pose&width=600&height=800&seq=tv-cover-5&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20mountain%20landscape%20at%20night%2C%20full%20moon%2C%20snow%20covered%20forest%2C%20traditional%20Japanese%20village%20in%20distance%2C%20mystical%20atmosphere%2C%20blue%20and%20white%20color%20palette%2C%20cinematic%20anime%20background&width=1600&height=600&seq=tv-banner-5&orientation=landscape",
    director: "外崎春雄",
    actors: ["花江夏树", "鬼头明里", "下野纮"],
    region: "日本",
    language: "日语",
    totalEpisodes: 55,
    status: "连载中",
    updateInfo: "更新至锻刀村篇",
    tags: ["热血", "战斗", "奇幻", "漫画改编"],
    episodes: [
      { id: 1, title: "残酷", duration: "24分钟" },
      { id: 2, title: "培育者 鳞泷左近次", duration: "24分钟" },
      { id: 3, title: "锖兔与真菰", duration: "24分钟" },
      { id: 4, title: "最终选拔", duration: "24分钟" },
    ],
    releaseDate: "2019-04-06",
  },
  {
    id: 6,
    title: "孤独的美食家",
    description: "进口杂货商井之头五郎在跑业务之余，独自一人走进街头巷尾的各类餐馆，享受美食带来的纯粹快乐。没有复杂的剧情，只有美食与治愈。",
    fullDescription: "进口杂货商井之头五郎在跑业务之余，独自一人走进街头巷尾的各类餐馆，享受美食带来的纯粹快乐。没有复杂的剧情，只有美食与治愈。本剧改编自久住昌之创作的同名漫画，松重丰完美诠释了一位中年大叔对美食的执着与热爱。每一集都是一次独立的美食之旅，从街边小吃到隐秘名店，五郎的内心独白和对食物的细致品评，让观众身临其境地感受日本各地的饮食文化。这是一部让人看了会饿的剧，也是一部让人感受生活美好的治愈佳作。",
    categoryId: "riju",
    year: 2012,
    rating: 9.0,
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20food%20drama%20poster%2C%20middle%20aged%20man%20enjoying%20meal%20at%20small%20restaurant%2C%20warm%20lighting%2C%20steaming%20food%20on%20table%2C%20cozy%20Japanese%20izakaya%20atmosphere%2C%20comforting%20and%20inviting%20mood%2C%20simple%20background&width=600&height=800&seq=tv-cover-6&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Cozy%20Japanese%20street%20food%20alley%20at%20dusk%2C%20warm%20lantern%20lights%2C%20small%20restaurants%20with%20noren%20curtains%2C%20steam%20rising%20from%20food%20stalls%2C%20nostalgic%20atmosphere%2C%20cinematic%20Japanese%20street%20scene&width=1600&height=600&seq=tv-banner-6&orientation=landscape",
    director: "溝口憲司",
    actors: ["松重丰"],
    region: "日本",
    language: "日语",
    totalEpisodes: 100,
    status: "连载中",
    updateInfo: "更新至第十季",
    tags: ["美食", "治愈", "日常", "漫画改编"],
    episodes: [
      { id: 1, title: "江东区门前仲町的烤鸡肉串", duration: "30分钟" },
      { id: 2, title: "丰岛区驹込的煮鱼定食", duration: "30分钟" },
      { id: 3, title: "台东区根岸的炸猪排", duration: "30分钟" },
      { id: 4, title: "千代田区神田的咖喱饭", duration: "30分钟" },
    ],
    releaseDate: "2012-01-04",
  },
  {
    id: 7,
    title: "繁花",
    description: "九十年代的上海，阿宝凭借改革开放的春风从平凡青年蜕变为商界后起之秀。黄河路上，人人都在追逐自己的繁花似锦。",
    fullDescription: "九十年代的上海，阿宝凭借改革开放的春风从平凡青年蜕变为商界后起之秀。黄河路上，人人都在追逐自己的繁花似锦。本剧由王家卫执导，胡歌、马伊琍、唐嫣等实力派演员主演，以极致的视觉美学和细腻的情感刻画，呈现了九十年代上海的繁华与沧桑。剧中每个镜头都如油画般精雕细琢，沪语对白更增添了浓郁的地域风情。这是一个关于时代、关于梦想、关于人情冷暖的故事，被誉为国产剧美学的全新高度。",
    categoryId: "guochan",
    year: 2023,
    rating: 8.7,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20drama%201990s%20Shanghai%20style%20poster%2C%20elegant%20man%20in%20vintage%20suit%2C%20nostalgic%20golden%20lighting%2C%20old%20Shanghai%20street%20atmosphere%2C%20cinematic%20Wong%20Kar%20Wai%20aesthetic%2C%20romantic%20and%20retro%20mood&width=600&height=800&seq=tv-cover-7&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20at%20night%2C%20neon%20signs%2C%20vintage%20cars%2C%20busy%20restaurants%20with%20red%20lanterns%2C%20nostalgic%20golden%20atmosphere%2C%20cinematic%20Wong%20Kar%20Wai%20style%2C%20warm%20amber%20tones&width=1600&height=600&seq=tv-banner-7&orientation=landscape",
    director: "王家卫",
    actors: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾"],
    region: "中国大陆",
    language: "汉语普通话 / 上海话",
    totalEpisodes: 30,
    status: "已完结",
    updateInfo: "全30集",
    tags: ["年代", "商战", "剧情", "爱情"],
    episodes: [
      { id: 1, title: "第一集", duration: "50分钟" },
      { id: 2, title: "第二集", duration: "50分钟" },
      { id: 3, title: "第三集", duration: "50分钟" },
      { id: 4, title: "第四集", duration: "50分钟" },
    ],
    releaseDate: "2023-12-27",
  },
  {
    id: 8,
    title: "鱿鱼游戏",
    description: "456名身负巨额债务的参赛者为了一笔足以改变命运的巨额奖金，参与了一系列致命的儿童游戏。每输一局，就有人永远离场。",
    fullDescription: "456名身负巨额债务的参赛者为了一笔456亿韩元的巨额奖金，参与了一系列致命的儿童游戏。每输一局，就有人永远离场。本剧由黄东赫执导，以极具视觉冲击力的场景设计和残酷的生存游戏设定，深刻讽刺了资本主义社会中人性在极端环境下的扭曲。剧中粉红色守卫服与绿色参赛服的鲜明对比、迷宫般的彩色楼梯、巨大的娃娃机器人等视觉元素，都已成为全球流行文化符号。该剧创下Netflix观看量最高纪录，引发全球现象级讨论。",
    categoryId: "hanju",
    year: 2021,
    rating: 8.0,
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20survival%20drama%20Squid%20Game%20style%20poster%2C%20geometric%20shapes%20in%20pink%20and%20green%2C%20mysterious%20masked%20figures%2C%20minimalist%20Korean%20design%2C%20bold%20color%20contrast%2C%20clean%20graphic%20style&width=600&height=800&seq=tv-cover-8&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Colorful%20geometric%20staircase%20in%20pink%20and%20mint%20green%2C%20surreal%20playground%20architecture%2C%20K-drama%20aesthetic%2C%20bright%20and%20eerie%20contrast%2C%20cinematic%20wide%20shot%2C%20clean%20minimalist%20design&width=1600&height=600&seq=tv-banner-8&orientation=landscape",
    director: "黄东赫",
    actors: ["李政宰", "朴海秀", "魏嘏隽", "郑好娟"],
    region: "韩国",
    language: "韩语",
    totalEpisodes: 9,
    status: "已完结",
    updateInfo: "全9集（第二季待播）",
    tags: ["生存", "惊悚", "社会讽刺", "剧情"],
    episodes: [
      { id: 1, title: "一二三，木头人", duration: "60分钟" },
      { id: 2, title: "地狱", duration: "63分钟" },
      { id: 3, title: "撑伞的男人", duration: "54分钟" },
    ],
    releaseDate: "2021-09-17",
  },
  {
    id: 9,
    title: "地球脉动 第三季",
    description: "BBC自然纪录片巅峰之作，历时五年拍摄，足迹遍布全球六大洲。从深海到高山，从极地到沙漠，记录地球上最壮观的自然奇观与野生动物生存故事。",
    fullDescription: "BBC自然纪录片巅峰之作，历时五年拍摄，足迹遍布全球六大洲。从深海到高山，从极地到沙漠，以8K超高清技术记录地球上最壮观的自然奇观与野生动物生存故事。大卫·爱登堡爵士的经典旁白配上汉斯·季默的震撼配乐，将大自然的壮美与残酷展现得淋漓尽致。本季聚焦于动物在日益变化的环境中展现出的惊人适应能力，每一帧画面都堪称自然摄影的教科书级别，是向地球生命致敬的影像诗篇。",
    categoryId: "jilupian",
    year: 2023,
    rating: 9.8,
    coverImage: "https://readdy.ai/api/search-image?query=BBC%20nature%20documentary%20Planet%20Earth%20style%20poster%2C%20magnificent%20mountain%20landscape%20with%20wildlife%20silhouette%2C%20golden%20sunrise%20light%2C%20epic%20natural%20scenery%2C%20cinematic%20documentary%20artwork%2C%20awe%20inspiring%20composition&width=600&height=800&seq=tv-cover-9&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Epic%20aerial%20view%20of%20Earth%20from%20space%20with%20sunrise%20on%20horizon%2C%20blue%20oceans%20and%20green%20continents%2C%20atmospheric%20clouds%2C%20planet%20Earth%20cinematic%20shot%2C%20NASA%20style%20photography%2C%20beautiful%20and%20majestic&width=1600&height=600&seq=tv-banner-9&orientation=landscape",
    director: "尼克·伊斯顿",
    actors: ["大卫·爱登堡"],
    region: "英国",
    language: "英语",
    totalEpisodes: 8,
    status: "已完结",
    updateInfo: "全8集",
    tags: ["自然", "纪录片", "BBC", "4K"],
    episodes: [
      { id: 1, title: "海岸", duration: "60分钟" },
      { id: 2, title: "海洋", duration: "60分钟" },
      { id: 3, title: "沙漠与草原", duration: "60分钟" },
    ],
    releaseDate: "2023-10-22",
  },
  {
    id: 10,
    title: "王牌对王牌 第八季",
    description: "王牌家族再次集结，沈腾、贾玲、华晨宇、关晓彤携手新老嘉宾，带来一季又一季的爆笑综艺盛宴，经典游戏全新升级。",
    fullDescription: "王牌家族再次集结，沈腾、贾玲、华晨宇、关晓彤携手新老嘉宾，带来一季又一季的爆笑综艺盛宴。经典游戏全新升级——传声筒、你画我猜、谁是卧底等王牌经典环节持续带来笑料不断。本季更有重量级飞行嘉宾加盟，经典剧组重聚环节催泪又暖心。作为国综常青树，《王牌对王牌》以其轻松愉快的氛围和真挚的团队情谊，成为无数观众周末的快乐源泉。",
    categoryId: "zongyi",
    year: 2023,
    rating: 7.8,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20colorful%20studio%20stage%20with%20spotlights%2C%20group%20of%20celebrities%20laughing%2C%20bright%20and%20energetic%20atmosphere%2C%20entertainment%20show%20design%2C%20vibrant%20colors%2C%20festive%20mood&width=600&height=800&seq=tv-cover-10&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Colorful%20TV%20studio%20stage%20with%20bright%20theatrical%20lighting%2C%20concert%20atmosphere%2C%20confetti%20and%20spotlights%2C%20entertainment%20show%20set%2C%20vibrant%20and%20lively%2C%20professional%20TV%20production%20look&width=1600&height=600&seq=tv-banner-10&orientation=landscape",
    director: "吴彤",
    actors: ["沈腾", "贾玲", "华晨宇", "关晓彤"],
    region: "中国大陆",
    language: "汉语普通话",
    totalEpisodes: 12,
    status: "连载中",
    updateInfo: "更新至第8期",
    tags: ["综艺", "搞笑", "游戏", "真人秀"],
    episodes: [
      { id: 1, title: "第一期：经典剧组重聚", duration: "90分钟" },
      { id: 2, title: "第二期：喜剧人大联欢", duration: "90分钟" },
      { id: 3, title: "第三期：音乐特辑", duration: "90分钟" },
    ],
    releaseDate: "2023-10-20",
  },
  {
    id: 11,
    title: "庆余年",
    description: "身世神秘的少年范闲，自幼跟随毒医费介学习医术和毒术。在经历种种历练后，他踏入京都，卷入了天下纷争与家族恩怨的漩涡之中。",
    fullDescription: "身世神秘的少年范闲，自幼跟随毒医费介学习医术和毒术。在经历种种历练后，他踏入京都，卷入了天下纷争与家族恩怨的漩涡之中。本剧改编自猫腻同名小说，以架空历史为背景，融合权谋、武侠、喜剧等多重元素。张若昀将范闲的机智、幽默与深情演绎得恰如其分，陈道明饰演的庆帝更是气场全开。第一季播出后口碑与热度双丰收，成为现象级网剧，第二季万众期待。",
    categoryId: "guochan",
    year: 2019,
    rating: 8.0,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20young%20man%20in%20ancient%20Chinese%20robe%20with%20sword%2C%20mysterious%20palace%20background%2C%20golden%20and%20red%20color%20scheme%2C%20cinematic%20wuxia%20style%2C%20epic%20fantasy%20artwork&width=600&height=800&seq=tv-cover-11&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20at%20sunset%2C%20grand%20architecture%20with%20golden%20roofs%2C%20misty%20mountains%20in%20background%2C%20epic%20historical%20fantasy%20setting%2C%20warm%20atmospheric%20lighting%2C%20cinematic%20wide%20shot&width=1600&height=600&seq=tv-banner-11&orientation=landscape",
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明", "吴刚"],
    region: "中国大陆",
    language: "汉语普通话",
    totalEpisodes: 46,
    status: "已完结",
    updateInfo: "全46集（第二季待播）",
    tags: ["古装", "权谋", "喜剧", "武侠"],
    episodes: [
      { id: 1, title: "第一集", duration: "45分钟" },
      { id: 2, title: "第二集", duration: "45分钟" },
      { id: 3, title: "第三集", duration: "45分钟" },
    ],
    releaseDate: "2019-11-26",
  },
  {
    id: 12,
    title: "进击的巨人",
    description: "在巨人的威胁下，人类被迫居住在巨大的城墙之内。少年艾伦·耶格尔目睹母亲被巨人吞噬后，立誓要消灭所有巨人，却发现了关于这个世界的惊人真相。",
    fullDescription: "在巨人的威胁下，人类被迫居住在巨大的城墙之内。少年艾伦·耶格尔目睹母亲被巨人吞噬后，立誓要消灭所有巨人，却发现了关于这个世界的惊人真相。本作改编自谏山创的同名漫画，由WIT STUDIO和MAPPA接力制作，以其宏大的世界观、残酷的生存叙事和深刻的哲学思辨，被誉为近十年来最具影响力的日本动画之一。从墙内到墙外，从复仇到反思，艾伦的旅程不断颠覆观众的认知，结局的争议更是引发了全球范围的讨论。",
    categoryId: "dongman",
    year: 2013,
    rating: 9.2,
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20anime%20Attack%20on%20Titan%20style%20poster%2C%20soldier%20with%20vertical%20maneuvering%20gear%2C%20giant%20titan%20in%20background%2C%20dramatic%20sky%2C%20action%20pose%2C%20dark%20and%20epic%20atmosphere%2C%20anime%20artwork&width=600&height=800&seq=tv-cover-12&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Massive%20ancient%20stone%20wall%20towering%20over%20medieval%20city%2C%20dramatic%20sky%20with%20clouds%2C%20sense%20of%20scale%20and%20confinement%2C%20anime%20style%20landscape%2C%20epic%20and%20mysterious%20atmosphere%2C%20cinematic%20fantasy%20setting&width=1600&height=600&seq=tv-banner-12&orientation=landscape",
    director: "林祐一郎",
    actors: ["梶裕贵", "石川由依", "井上麻里奈"],
    region: "日本",
    language: "日语",
    totalEpisodes: 87,
    status: "已完结",
    updateInfo: "全四季完结",
    tags: ["热血", "奇幻", "战争", "悬疑"],
    episodes: [
      { id: 1, title: "致两千年后的你", duration: "24分钟" },
      { id: 2, title: "那一天", duration: "24分钟" },
      { id: 3, title: "绝望中的微光", duration: "24分钟" },
    ],
    releaseDate: "2013-04-07",
  },
];

export const featuredIds = [2, 7, 3, 1, 8, 11];

export const testimonials = [
  {
    id: 1,
    name: "王先生",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20headshot%2C%20neutral%20expression%2C%20simple%20light%20background%2C%20clean%20studio%20lighting%2C%20corporate%20style&width=100&height=100&seq=avatar-1&orientation=squarish",
    content: "四虎影视大全真的太好用了！之前找剧要在不同平台跳来跳去，现在一个网站就能看到所有热门剧集的全集。画质清晰，更新也快，推荐给了身边所有追剧的朋友。",
    rating: 5,
    date: "2024年3月",
  },
  {
    id: 2,
    name: "李女士",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20headshot%2C%20warm%20smile%2C%20simple%20light%20background%2C%20clean%20studio%20lighting%2C%20corporate%20style&width=100&height=100&seq=avatar-2&orientation=squarish",
    content: "作为一个追剧狂魔，四虎影视大全简直是救命神器。分类清晰、搜索方便，最重要的是全集一次看完不用等更新，太爽了！已经安利给全家人了。",
    rating: 5,
    date: "2024年5月",
  },
  {
    id: 3,
    name: "张同学",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20headshot%2C%20casual%20style%2C%20friendly%20expression%2C%20simple%20light%20background%2C%20clean%20studio%20lighting&width=100&height=100&seq=avatar-3&orientation=squarish",
    content: "室友推荐的，一开始还不太相信免费的能有多好。用了之后真香了！资源全、无广告、播放流畅，学习累了追两集剧放松一下，简直不要太舒服。",
    rating: 4,
    date: "2024年6月",
  },
  {
    id: 4,
    name: "赵老师",
    avatar: "https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20woman%20portrait%20headshot%2C%20gentle%20smile%2C%20simple%20light%20background%2C%20clean%20studio%20lighting%2C%20professional%20style&width=100&height=100&seq=avatar-4&orientation=squarish",
    content: "退休之后最大的爱好就是看电视剧。女儿给我推荐的四虎影视大全，操作简单，字体也大，看起来不费劲。国产剧、韩剧应有尽有，每天都有新剧看，晚年生活丰富多了。",
    rating: 5,
    date: "2024年7月",
  },
];

export const faqItems = [
  {
    question: "四虎影视大全是否需要注册账号？",
    answer: "不需要。四虎影视大全完全免费，无需注册即可畅享所有电视剧资源。我们致力于为用户提供最简单便捷的观影体验，打开网站就能直接观看。",
  },
  {
    question: "网站上的电视剧资源是否高清？",
    answer: "是的，四虎影视大全提供的所有电视剧资源均为高清画质（1080P及以上）。我们持续优化播放技术，确保用户在不同网络环境下都能获得流畅清晰的观影体验。",
  },
  {
    question: "四虎影视大全的更新速度如何？",
    answer: "我们拥有专业的资源更新团队，热门剧集通常在上线后24小时内即可同步更新。用户可以通过首页的「最近更新」栏目第一时间发现最新上线的剧集内容。",
  },
  {
    question: "可以在手机上使用四虎影视大全吗？",
    answer: "完全可以。四虎影视大全采用响应式设计，自动适配手机、平板和电脑等多种设备。无论您使用什么设备，都能获得一致的优质观影体验。",
  },
  {
    question: "如果遇到播放问题该怎么办？",
    answer: "如遇到播放卡顿或无法播放的情况，建议您先检查网络连接，或尝试切换播放线路。若问题持续存在，欢迎通过关于我们页面的联系方式与我们取得联系，我们会尽快处理。",
  },
];